// extracted by mini-css-extract-plugin
module.exports = {"amenities":"style_amenities__O4lOe","amenity":"style_amenity__3Zcjd","active":"style_active__3Ow67","icon":"style_icon__3Kd9l"};